<template>
  <div class="container_row">
    <!-- <pre>{{ result_value }}</pre> -->
    <div class="card-div col_1" style="position: relative;">
      <div class="location-title">Location</div>
      <mapdashboard />
    </div>
    <div class="card-div col_2_1_1">
      <powerconsumption
        :header="'Total Power Consumption'"
        :value_day="result_value.day.kWh" 
        :value_month="result_value.month.kWh"
        :value_year="result_value.year.kWh"
      />
    </div>
    <div class="card-div col_2_1_2">
      <powerconsumption
        :header="'Total Rain Volume'"
        :value_day="result_value.day.Rain"
        :value_month="result_value.month.Rain"
        :value_year="result_value.year.Rain"
      />
    </div>
    <div class="card-div col_2_2_1" align="center" style="margin: 0 20%">
      <h3 style="font-weight: 600; color: #707070" class="p-3">
        Monthly Water Level
      </h3>
    </div>
    <div class="card-div col_2_3_1">
      <station_header :header="'Station 06'" />
    </div>
    <div class="card-div col_2_3_2">
      <station_header :header="'Station 07'" />
    </div>
    <div class="card-div col_2_3_3">
      <station_header :header="'Station 10'" />
    </div>
    <div class="card-div col_2_4_1 img_bg1">
      <textlevel
        :header="'Pond Water Level'"
        :show_setting="false"
        :value="result_value.station6.Level_1S"
        :a="true"
      />
    </div>
    <div class="card-div col_2_4_2 img_bg1">
      <textlevel
        :header="'Pond Water Level'"
        :show_setting="false"
        :value="result_value.station7.Level_1S"
        :a="true"
      />
    </div>
    <div class="card-div col_2_4_3 img_bg1">
      <textlevel
        :header="'Pond Water Level'"
        :show_setting="false"
        :value="result_value.station10.Level_1S"
        :a="true"
      />
    </div>
    <div class="card-div col_2_5_1 img_bg2">
      <textlevel
        :header="'Canal Water Level'"
        :show_setting="false"
        :value="result_value.station6.Level_2S"
        :a="true"
      />
    </div>
    <div class="card-div col_2_5_2 img_bg2">
      <textlevel
        :header="'Canal Water Level'"
        :show_setting="false"
        :value="result_value.station7.Level_2S"
        :a="true"
      />
    </div>
    <div class="card-div col_2_5_3 img_bg2">
      <textlevel
        :header="'Canal Water Level'"
        :show_setting="false"
        :value="result_value.station10.Level_2S"
        :a="true"
      />
    </div>
  </div>
</template>

<script>
import textlevel from "./components/div/divlevel.vue";
import station_header from "./components/div/station_overview.vue";
import powerconsumption from "./components/div/power_consumtion_overview.vue";
import mapdashboard from "./components/div/map.vue";
export default {
  components: {
    textlevel,
    station_header,
    powerconsumption,
    mapdashboard,
  },
  data() {
    return {
      result_value: [],
    };
  },
  async mounted() {
    this.$WSS.connect("FPS-demo");
    this.$WSS.emit("FPS-dashboard", "message");
    this.$WSS.on("connect", () => {
      console.log("socket id", this.$WSS.socket().id);
    });
    this.$WSS.on("FPS-dashboard", (messageNew) => {
      console.log(
        "FPS-dashboard",
        messageNew,
        this.$moment().format("HH:mm:ss")
      );
      this.result_value = messageNew.message;
    });
  },
  beforeDestroy() {
    this.$WSS.disconnect();
  },
};
</script>

<style scoped>
.container_row {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr 0.5fr 0.5fr 1fr 1fr 1fr 1fr;
  gap: 15px 20px;
  grid-auto-flow: row;
  grid-template-areas:
    "col_1 col_1 col_1 col_1 col_1 col_2_1_1 col_2_1_1 col_2_1_1 col_2_1_2 col_2_1_2 col_2_1_2"
    "col_1 col_1 col_1 col_1 col_1 col_2_1_1 col_2_1_1 col_2_1_1 col_2_1_2 col_2_1_2 col_2_1_2"
    "col_1 col_1 col_1 col_1 col_1 col_2_2_1 col_2_2_1 col_2_2_1 col_2_2_1 col_2_2_1 col_2_2_1"
    "col_1 col_1 col_1 col_1 col_1 col_2_3_1 col_2_3_1 col_2_3_2 col_2_3_2 col_2_3_3 col_2_3_3"
    "col_1 col_1 col_1 col_1 col_1 col_2_4_1 col_2_4_1 col_2_4_2 col_2_4_2 col_2_4_3 col_2_4_3"
    "col_1 col_1 col_1 col_1 col_1 col_2_4_1 col_2_4_1 col_2_4_2 col_2_4_2 col_2_4_3 col_2_4_3"
    "col_1 col_1 col_1 col_1 col_1 col_2_5_1 col_2_5_1 col_2_5_2 col_2_5_2 col_2_5_3 col_2_5_3"
    "col_1 col_1 col_1 col_1 col_1 col_2_5_1 col_2_5_1 col_2_5_2 col_2_5_2 col_2_5_3 col_2_5_3";
}
.card-div {
  background: white;
  border-radius: 30px;
  -webkit-box-shadow: 0 4px 25px 0 rgb(0 0 0 / 10%);
  box-shadow: 0 4px 25px 0 rgb(0 0 0 / 10%);
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
}

.location-title {
  position: absolute;
  top: 30px;
  left: 30px;
  color: rgb(0, 0, 0);
  z-index: 1;
  font-size: 48px;
  line-height: 48px;
  display: inline-block;
}
.col_1 {
  grid-area: col_1;
}

.col_2_1_1 {
  grid-area: col_2_1_1;
}

.col_2_1_2 {
  grid-area: col_2_1_2;
}

.col_2_2_1 {
  grid-area: col_2_2_1;
}

.col_2_3_1 {
  grid-area: col_2_3_1;
}

.col_2_3_2 {
  grid-area: col_2_3_2;
}

.col_2_3_3 {
  grid-area: col_2_3_3;
}

.col_2_4_1 {
  grid-area: col_2_4_1;
}

.col_2_4_2 {
  grid-area: col_2_4_2;
}

.col_2_4_3 {
  grid-area: col_2_4_3;
}

.col_2_5_1 {
  grid-area: col_2_5_1;
}

.col_2_5_2 {
  grid-area: col_2_5_2;
}

.col_2_5_3 {
  grid-area: col_2_5_3;
}
.img_bg1 {
  background-image: url("../../../../assets/images/NikhomLatKrabang/Pond Water Level .gif");
  background-size: cover;
  /* height: 200px; */
}
.img_bg2 {
  background-image: url("../../../../assets/images/NikhomLatKrabang/Canal Water Level.gif");
  background-size: cover;
  /* height: 200px; */
}
@media only screen and (max-width: 767px) {
  .container_row {
    display: grid;
    grid-template-columns: 100%;
    grid-template-rows: auto;
    /* grid-auto-rows: 1fr; */
    gap: 15px 10px;
    grid-auto-flow: row;
    grid-template-areas:
      "col_1"
      "col_2_1_1"
      "col_2_1_2"
      "col_2_2_1"
      "col_2_3_1"
      "col_2_4_1"
      "col_2_5_1"
      "col_2_3_2"
      "col_2_4_2"
      "col_2_5_2"
      "col_2_3_3"
      "col_2_4_3"
      "col_2_5_3";
    /* grid-template-areas:
      "col_1 col_1 col_1 col_1 col_1 col_2_1_1 col_2_1_1 col_2_1_1 col_2_1_2 col_2_1_2 col_2_1_2"
      "col_1 col_1 col_1 col_1 col_1 col_2_1_1 col_2_1_1 col_2_1_1 col_2_1_2 col_2_1_2 col_2_1_2"
      "col_1 col_1 col_1 col_1 col_1 col_2_2_1 col_2_2_1 col_2_2_1 col_2_2_1 col_2_2_1 col_2_2_1"
      "col_1 col_1 col_1 col_1 col_1 col_2_3_1 col_2_3_1 col_2_3_2 col_2_3_2 col_2_3_3 col_2_3_3"
      "col_1 col_1 col_1 col_1 col_1 col_2_4_1 col_2_4_1 col_2_4_2 col_2_4_2 col_2_4_3 col_2_4_3"
      "col_1 col_1 col_1 col_1 col_1 col_2_4_1 col_2_4_1 col_2_4_2 col_2_4_2 col_2_4_3 col_2_4_3"
      "col_1 col_1 col_1 col_1 col_1 col_2_5_1 col_2_5_1 col_2_5_2 col_2_5_2 col_2_5_3 col_2_5_3"
      "col_1 col_1 col_1 col_1 col_1 col_2_5_1 col_2_5_1 col_2_5_2 col_2_5_2 col_2_5_3 col_2_5_3"; */
  }
}
</style>